import React, { Component } from 'react';
import strings from '../../../../../assets/strings';
import './styles.less';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { withTheme, withStyles } from '@material-ui/styles';

const StyledAlert = withStyles({
  root: {
    '& .MuiAlert-message': {
      lineHeight: '1.6'
    },
    borderRadius: '4px',
    height: '60px',
    alignItems: 'flex-start',
    overflow: 'hidden'
  }
})(MuiAlert);

const SponsorAlert = withStyles({
  root: {
    backgroundColor: '#325C41 !important',
    color: 'whitesmoke !important',
    '& .MuiAlert-icon': {
      alignSelf: 'flex-start',
      color: 'whitesmoke !important'
    },
    '& .MuiAlert-message': {
      lineHeight: '1.6'
    },
    borderRadius: '4px',
    height: '60px',
    alignItems: 'flex-start',
    overflow: 'hidden'
  }
})(MuiAlert);

function Alert(props) {
  const { severity, ...otherProps } = props;
  const AlertComponent = severity === 'sponsor' ? SponsorAlert : StyledAlert;
  const alertSeverity = severity === 'sponsor' ? 'info' : severity;
  
  return <AlertComponent elevation={6} variant="filled" severity={alertSeverity} {...otherProps} />;
}

class SandboxTitle extends Component {
  constructor(props) {
    super(props);

    let message = this.props.settings.announcement ? this.props.settings.announcement.message : null;
    let start = new Date(this.props.settings.announcement ? this.props.settings.announcement.startDate : null);
    let end = new Date(this.props.settings.announcement ? this.props.settings.announcement.endDate : null);
    let current = new Date();
    let isPermanent = this.props.settings.announcement && this.props.settings.announcement.permanent === true;

    this.state = {
      openSnackbar: message && !isNaN(end) && end > current || message && !isNaN(start) && start <= current,
      severity: this.props.settings.announcement && this.props.settings.announcement.severity ? this.props.settings.announcement.severity : "info",
      isPermanent: isPermanent
    };
  }

  handleClose = () => {
    if (!this.state.isPermanent) {
      this.setState({
        openSnackbar: false
      });
    }
  };

  handleMouseEnter = () => {
    // If there's an existing timer, clear it
    if (this.snackbarTimer) {
      clearTimeout(this.snackbarTimer);
    }
  };

  handleMouseLeave = () => {
    if (!this.state.isPermanent) {
      // Start a new timer when mouse leaves
      this.snackbarTimer = setTimeout(() => {
        this.setState({ openSnackbar: false });
      }, 8000);
    }
  };

  componentWillUnmount() {
    // Clean up timer if component unmounts
    if (this.snackbarTimer) {
      clearTimeout(this.snackbarTimer);
    }
  }

  render() {
    const messageStyle = {
      color: this.state.severity === 'warning' ? 'black' : 'inherit'
    };

    // Process message to make first sentence bold
    let processedMessage = this.props.settings.announcement ? this.props.settings.announcement.message : '';
    const firstSentenceMatch = processedMessage.match(/^(.*?\.)/);
    if (firstSentenceMatch) {
      const firstSentence = firstSentenceMatch[1];
      const rest = processedMessage.substring(firstSentence.length);
      processedMessage = `<strong>${firstSentence}</strong>${rest}`;
    }

    return this.state.openSnackbar ? (
      <Snackbar
        open={this.state.openSnackbar}
        autoHideDuration={this.state.isPermanent ? null : 8000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={this.handleClose}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        style={{ top: 0, maxWidth: '1064px', width: 'calc(100% - 40px)' }}
      >
        <Alert severity={this.state.severity} onClose={this.state.isPermanent ? undefined : this.handleClose}>
          <div
            dangerouslySetInnerHTML={{ __html: processedMessage }}
            style={messageStyle}
          />
        </Alert>
      </Snackbar>
    ) : (
      <div className='sandbox-title'>{strings.defaultSandboxTitle}</div>
    );
  }
}


export default withTheme(SandboxTitle);



// WEBPACK FOOTER //
// ./src/components/UI/Navigation/Toolbar/SandboxTitle/index.js